// extracted by mini-css-extract-plugin
export default {"root":"n8roiE_BKsiLtxMHruA5","num":"XEWNKz5ZqHdC3T6Cgbti","placeHolderShimmer":"saC6PSZF9wvRIBwSv3M5"};